import React from 'react';
import { BrowserRouter as Router, Route, Link, useNavigate} from 'react-router-dom';
import { Box, Typography, Link as MuiLink } from '@mui/material';
import { grey, blue } from '@mui/material/colors';
import { useState, useEffect } from 'react';
import axios from 'axios'


import sangerImage from '../../images/aboutuspage-img01.png'
import fragmentImage from '../../images/aboutuspage-img04.png'

const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV
    
const UploadSelect = () => {

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(API_ENDPOINT + '/user/new')
      .then((res) => {
        if (res.status === 200) {
          //Do nothing
        }
      })
      .catch(function (error) {
        if (error.response && error.response.status === 302) {
          navigate('/profile', { replace: true });
        }
      });
  }, []);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <h1 style={{ marginBottom: 10 }}>Please select the type of order you'd like to submit</h1>
      <Rectangle 
        imageSrc={sangerImage}
        title="Sanger Sequencing"
        description="Sanger Sequencing is a pivotal DNA sequencing technique that deciphers genetic code with high precision, enabling groundbreaking advancements in molecular biology and medicine."
        linkTo="/Upload/Sanger"
      />
      <Rectangle 
        imageSrc={fragmentImage}
        title="Fragment Analysis"
        description="Fragment Analysis is an advanced genomics technique that sorts and quantifies DNA fragments, enabling detailed genetic variation studies and enhancing diagnostics precision."
        linkTo="/Upload/Fragment"
      />
    </div>
  );
};    

export default UploadSelect;

const CustomLink = ({ to, children }) => (
    <MuiLink component={Link} to={to} underline="none" color="inherit">
      {children}
    </MuiLink>
  );
  
  const Rectangle = ({ imageSrc, title, description, linkTo }) => {
    const [isHovered, setIsHovered] = useState(false);
  
    return (
      <CustomLink to={linkTo}>
        <Box
          display="flex"
          width="80vw"
          height="40vh"
          borderColor={blueTextColor}
          border={2}
          mb={2}
          onMouseEnter={() => setIsHovered(true)}  // Set isHovered to true when mouse enters
          onMouseLeave={() => setIsHovered(false)} // Set isHovered to false when mouse leaves
          sx={{
            '&:hover': {
              bgcolor: priceColor,
              borderColor: lightBlueTextColor,
              borderWidth: 3,
              '& h3': { color: detailBackgroundColor },
              '& p': { color: titleBackgroundColor },
            },
            transition: 'background-color 0.3s, border-color 0.3s',
          }}
        >
          <Box 
            component="div" 
            display="flex" 
            alignItems="center" 
            justifyContent="center" 
            bgcolor={isHovered ? priceColor : titleBackgroundColor}
            width="40%" 
            height="100%" 
          >
            <img src={imageSrc} alt={title} style={{ width: '100%', height: '100%', opacity: isHovered ? "25%" : "100%" }} />
          </Box>
          <Box 
            flex={1} 
            display="flex" 
            flexDirection="column" 
            justifyContent="center" 
            pl={2}
            bgcolor={isHovered ? priceColor : detailBackgroundColor}
          >
            <h3 style={{ color: isHovered ? detailBackgroundColor : blueTextColor, fontSize: 65, margin: 0 }}>{title}</h3>
            <p style={{ color: isHovered ? detailBackgroundColor : blueTextColor }}>{description}</p>
          </Box>
        </Box>
      </CustomLink>
    );
  };
  
  const techGold = "rgb(179, 163, 105)";
  const priceColor = "rgb(125, 170, 185)";
  const blueTextColor = "rgb(0, 48, 87)";
  const lightBlueTextColor = "rgb(0, 138, 252)";
  const titleBackgroundColor = 'rgb(233, 235, 230)';
  const detailBackgroundColor = 'rgb(246, 249, 245)';
  